import React from "react";
import Navbar from "@/components/Navbar";
import ProfileForm from "@/components/ProfileForm";
import { useAuth } from "@/contexts/AuthContext";

export default function Profile() {
  const { user, checkAuth } = useAuth();
  if (!user) return null;

  return (
    <div className="min-h-screen bg-[#FBF9F6]">
      <Navbar />
      <main
        data-testid="profile-page"
        className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-12"
      >
        <div className="mb-8">
          <h1 className="font-serif text-4xl sm:text-5xl text-[#2D2926] leading-tight">
            Your profile
          </h1>
          <p className="mt-3 text-sm text-[#6B655D] leading-relaxed max-w-lg">
            A little context helps your colleagues talk to you like a person, not
            a stranger. Everything's optional — share as much or as little as
            feels right. We don't share, sell, or train on this.
          </p>
        </div>
        <div className="bg-white border border-[#E6E2D8] rounded-3xl p-6 sm:p-8 shadow-sm">
          <ProfileForm
            initial={user.profile || {}}
            submitLabel="Save profile"
            onSaved={() => checkAuth()}
          />
        </div>
      </main>
    </div>
  );
}
